import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpacebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSpacebar"><Path d="M4 13V18H20V13H22V20H2V13H4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpacebar;
